import {createFileRoute} from '@tanstack/react-router';
import AppHome from '@/anonymous/views/AppHome';

export const Route = createFileRoute('/(anonymous)/app-home')({
  component: AppHome
});
